import { ModalProps } from "../../../types/modalProps";
import { User } from "../../../models/user.model";
import { responseHero } from "../../../utils/axiosInterceptor";
import { toast } from "react-toastify";
const PasswordHelper = ({ title, user, showModal, closeModal } : Omit<ModalProps, "handleStateChange">) => {


    const sendMail = async (user: User | undefined) => {
        if (!user?.email) {
            toast.error("Kérjük adja meg az email címét!");
            return;
        }

        const validatedEmail = user?.email;

        const response = await responseHero.get(`${process.env.REACT_APP_API_URL}/checkEmailValidity/${validatedEmail}`);
        if(!response.data.valid) {
            return toast.error('Az email cím nem szerepel a rendszerben, kérjük ellenőrizze az email címét!');
        }


        toast.info("A levél küldése folyamatban... Kérem várjon!");

        const payload = {
            from: process.env.REACT_APP_NEWSLETTER_SENDER,
            to: [validatedEmail],
        }

        await responseHero.post(`${process.env.REACT_APP_API_URL}/forgetPassword`, { email: payload }).then((response) => {
                toast.success('Sikeres kézbesítés, kérjük ellenőrizze email fiókját, a levél rövidesen megérkezik!');
            }).catch((error) => {
                console.error(error)
                toast.error('Sikertelen kézbesítés, kérjük lépjen velünk kapcsolatba email-en / telefonon!');
        });
    };

  return (
    <>
        {showModal && (
            <>
            <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t ">
                        <h3 className="text-3xl font=semibold">{title}</h3>
                        </div>
                        <div className="relative p-6 flex-auto">
                            <p className="text-xl mb-2">Biztosan kiküldöd <b>{user?.name}</b> részére a jelszó-emlékeztető email-t?</p>
                            <p className="text-md py-1">Az ügyfél ezzel egy linket kap email-ben, amire rákattintva beállíthat egy <b>új jelszót.</b></p>
                            <p className="text-md py-1">A <b>{user?.email}</b> email cím és az <b>általa beállított</b> jelszó használatával az ügyfélportál és a mobilapplikáció is használható.</p>
                        </div>
                        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                        <button
                            className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                            type="button"
                            onClick={closeModal}
                        >
                            Mégse
                        </button>
                        <button
                            className="text-cream bg-dark-blue font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                            type="button"
                            onClick={() => sendMail(user)}
                        >
                            Küldés
                        </button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )}
    </>
  );
};

export default PasswordHelper;